import { AccountSetupPayload } from "../../db/action/accountSetup";
import { BaseResponse } from "../../db/response";
import errorHandler from "../../utils/errorHandler";
import { setPasswordByInvitationToken } from "../../api/services/accountManagement.service";

export interface AccountSetupResponse extends BaseResponse {
  data?: {
    message: string;
    userId?: string;
    accountId?: string;
  };
}

/**
 * Account setup via Account Management API: POST /accounts/invitation/{token}
 * Request body: SetPasswordRequest (email, password, termsAndConditionsAccepted).
 */
export const doAccountSetup = async (
  params: AccountSetupPayload,
): Promise<AccountSetupResponse> => {
  try {
    const response = await setPasswordByInvitationToken(
      params.invitationToken,
      {
        email: params.accountOwnerEmail,
        password: params.password,
        termsAndConditionsAccepted: true,
      }
    );

    if (response.status === "SUCCESS") {
      return {
        status: "SUCCESS" as const,
        statusinfo: response.statusinfo,
        data: {
          message: response.statusinfo?.message || response.data?.message || "Account setup completed successfully",
        },
      };
    }

    return {
      status: "FAILURE" as const,
      statusinfo: response.statusinfo,
    };
  } catch (error) {
    return errorHandler(error);
  }
};

